module.exports = __webpack_public_path__ + "img/create-meeting.3bb7ba05.jpg";